export const breakpoint = {
  pcWide: 1400,
  pc: 1240,
  tab: 993,
  mobile: 590,
  mobileNarrow: 320,
}